import { render, staticRenderFns } from "./payBills.vue?vue&type=template&id=4d52dd23&scoped=true&"
import script from "./payBills.vue?vue&type=script&lang=js&"
export * from "./payBills.vue?vue&type=script&lang=js&"
import style0 from "./payBills.vue?vue&type=style&index=0&id=4d52dd23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52dd23",
  null
  
)

export default component.exports